/**
 * @desc 销售报价报表导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.ListingQuoteRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/listingQuote/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
